import {
    apiRequest,
    rekapList
} from "../../../../../services/adapters/kepegawaian/rekapAbsensiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", rekapList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository